import styled from '@emotion/styled';

export const ReportContainer = styled.div`
  position: relative;
  max-height: 900px;
  width: 100%;

  iframe {
    width: 100%;
    height: 700px !important;
    border: none !important;
  }
`;
